import { useDebouncedProp, useDOMRect } from '@anton.bobrov/react-hooks';
import { vevet } from '@anton.bobrov/vevet-init';
import { useMemo, useState, useCallback, useEffect } from 'react';

function useFormSelectWrapperMaxHeight({
  element,
  isActive: isActiveProp
}) {
  const isActive = useDebouncedProp(isActiveProp, 10);
  const ref = useMemo(() => ({ current: element }), [element]);
  const bounding = useDOMRect({ ref, isDisabled: !isActive });
  const [position, setPosition] = useState();
  const updatePosition = useCallback((parent) => {
    if (parent?.classList.contains("rkc-vertical_up")) {
      setPosition("up");
    } else if (parent?.classList.contains("rkc-vertical_down")) {
      setPosition("down");
    } else {
      setPosition(null);
    }
  }, []);
  useEffect(() => {
    const parent = element?.parentElement;
    if (!parent) {
      return void 0;
    }
    updatePosition(parent);
    const observer = new MutationObserver(() => updatePosition(parent));
    observer.observe(parent, {
      attributes: true,
      attributeFilter: ["class"]
    });
    return () => observer.disconnect();
  }, [element, updatePosition]);
  const maxHeight = useMemo(() => {
    if (!bounding) {
      return void 0;
    }
    if (position === "up") {
      return bounding.bottom - 60;
    }
    if (position === "down") {
      return vevet.viewport.height - bounding.top - 60;
    }
    return void 0;
  }, [bounding, position]);
  return maxHeight;
}

export { useFormSelectWrapperMaxHeight };
//# sourceMappingURL=useFormSelectWrapperMaxHeight.js.map
